import { render } from "./create.vue?vue&type=template&id=3d613e8a&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=3d613e8a&scoped=true&lang=scss"

import exportComponent from "/Users/andressantos/Documents/kevin/matrix_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d613e8a"]])

export default __exports__